import { Fragment, useEffect, useState, useContext, useRef } from "react";
import { Dialog, Transition, Menu } from "@headlessui/react";
import { Context } from "../themeContext";

import { Link, NavLink } from "react-router-dom";
//import PersonalInformation2  from "../profile/p"
import Toggle from "./../themeToggle";

import { ChevronDownIcon } from "@heroicons/react/solid";
import { toast } from "react-toast";

import axios from "axios";
import Webphone from "../webphone/Webphone";
import { MenuIcon, XIcon, ChevronRightIcon } from "@heroicons/react/outline";

import {
  Users,
  Clock,
  BookOpen,
  Voicemail,
  User,
  Settings,
  LogOut,
  CheckCircle,
  Share2,
} from "react-feather";

import imageSrcCMK from "./logoCMK.png";
import imageSrcGO from "./logoGO.png";
import { useTranslation, withTranslation } from "react-i18next";
import { renderStatus } from "../utils";
import { Divider, notification } from "antd";
import isFirstDayOfMonth from "date-fns/isFirstDayOfMonth/index";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { socket } from "../webphone/dropdown/socketUse";
import CryptoJS from "crypto-js";
import { decryptC } from "../utils/util";

//import { Link } from "react-router-dom";

// const navigation = [
//   { name: "Dashboard", href: "#", icon: HomeIcon, current: true },
//   { name: "Team", href: "#", icon: UsersIcon, current: false },
//   { name: "Projects", href: "#", icon: FolderIcon, current: false },
//   { name: "Calendar", href: "#", icon: CalendarIcon, current: false },
//   { name: "Documents", href: "#", icon: InboxIcon, current: false },
//   { name: "Reports", href: "#", icon: ChartBarIcon, current: false },
// ];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const isWEB = localStorage.getItem("isWEB");
const infoTag = localStorage.getItem("infoTag");
const idTag = localStorage.getItem("idTag");
// const encodedString = utf8.encode(infoTag);
const BackendURL = window.BackendURLCmk;
function Sidebar() {
  // config rmc
  const tag = CryptoJS.AES.decrypt(idTag, "m@123").toString(CryptoJS.enc.Utf8);

  const tagInfo = CryptoJS.AES.decrypt(infoTag, tag).toString(
    CryptoJS.enc.Utf8
  );
  const tagInfoSplit = tagInfo.split("/*/");
  const access_rmc = decryptC(tagInfoSplit[3]);
  const url_rmc = decryptC(tagInfoSplit[4]);
  const token_rmc = decryptC(tagInfoSplit[5]);
  // rmc config end
  const { t } = useTranslation("common");
  const [state, dispatch] = useContext(Context);
  const history = useHistory();
  const isActive = (path, match, location) =>
    !!(match || path === location.pathname);
  const [etattransfert, setetattransfert] = useState(false);
  const [profile, setProfile] = useState([]);
  const [letter, setLetter] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [show, setShow] = useState(false);
  const isLoggingOutRef = useRef(false);
  const hideModal = () => setShow(false);
  const showModal = () => setShow(true);

  const forceLogout = () => {
    if (isLoggingOutRef.current) return;
    isLoggingOutRef.current = true;

    const cmkPhone = state?.cmkPhone;
    if (typeof cmkPhone?.unregister === "function") {
      cmkPhone.unregister();
    }
    if (typeof cmkPhone?.stop === "function") {
      cmkPhone.stop();
    }

    const appSocket = state?.socket;
    if (typeof appSocket?.off === "function") {
      appSocket.off();
    }

    localStorage.clear();
    window.location.href = "/";
    setTimeout(() => {
      localStorage.clear();
    }, 100);
  };
  const navigation = [
    // { name: "Accueil", href: "/", icon: Home, current: false },
    { name: t("colleguetitle"), href: "/", icon: Users, current: false },
    // { name: "Journal", href: "/journal", icon: Clock, current: false },
    { name: "Contacts", href: "/contact", icon: BookOpen, current: false },
    // {
    //   name: t("boitevocale"),
    //   href: "/boitevocale",
    //   icon: Voicemail,
    //   current: false,
    // },

    // { name: "Reports", href: "#", icon: BarChart2, current: false },
    // { name: "Profil", href: "#", icon: User, current: false },
    // { name: "Paramètres", href: "#", icon: Settings, current: false },
  ];

  const fetchmsgvocal = () => {
    var lien = window.location.href;
    const var2 = lien.split("/");
    var var4 = var2[2].split(":");
    var config = {
      headers: {
        Authorization: token,
      },
    };
    const res = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/MessagesVocauxIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filtre=nouveau`,
        config
      )
      .then((res) => {
        const data2 = res.data.log_voicemail.reverse();
        var data3 = res.data.log_voicemail.length;
        dispatch({ type: "MSG_vocaux", payload: data3 });
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };
  const fetchData1 = () => {
    var lien = window.location.href;

    const var2 = lien.split("/");

    var var4 = var2[2].split(":");

    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/EtatRenvoiDirectIPBXV3API?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        if (res.data.etat_ws == "activer") {
          //  setetattransfert(true);
          dispatch({ type: "SET_Renvoi_direct" });
        }
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };
  const fetchDataexterne = async () => {
    var lien = window.location.href;

    const var2 = lien.split("/");

    var var4 = var2[2].split(":");

    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/EtatRenvoiInjoignabiliterExterneIPBXV3API?compte=${compte}&poste=${poste}`,

        config
      )
      .then((res) => {
        if (res.data.etat_renvoi == "activer") {
          // setetattransfert(true);
          switch (res.data.default_action_externe) {
            case "1":
              dispatch({ type: "SET_Renvoi_externe" });
              break;
            case "10":
              dispatch({ type: "SET_Renvoi_externe" });
              break;
          }
        }
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };
  const fetchDatainterne = async () => {
    var lien = window.location.href;

    const var2 = lien.split("/");

    var var4 = var2[2].split(":");

    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/EtatRenvoiInjoignabiliterInterneIPBXV3API?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        if (res.data.etat_renvoi == "activer") {
          //setetattransfert(true);
          switch (res.data.default_action) {
            case "1":
              dispatch({ type: "SET_Renvoi_interne" });
              break;

            case "10":
              dispatch({ type: "SET_Renvoi_interne" });
              break;
            default:
          }
        }
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };
  function showModal2() {
    var config = {
      headers: {
        Authorization: token,
      },
    };
    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/DeconnexionIPBXV3API?compte=${compte}&poste=${poste}`,
        config
      )
      .then(() => {
        forceLogout();
        //  setProfile(res.data.collegues[0]);
        //console.log(res.data.collegues[0].nom[0])
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
        forceLogout();
      });
  }

  const showCustom = (appel) =>
    toast("Vous avez un appel manqué de la part de ", {
      backgroundColor: "#27d0b2",
      color: "#ffffff",
      position: "absolute",
    });
  function onclicketat() {
    // setshowetat("no");
    document.getElementById("notif").classList.remove("bg-opacity-100");
  }

  // function showNotification() {
  //   new Notification("Hey");
  //   console.log("heeeeeeeeeeeeeeeeeeeeeeeee");
  // }
  function notifyMe(num) {
    if (Notification.permission !== "granted") Notification.requestPermission();
    else {
      try {
        var notification = new Notification("", {
          icon: "https://www.comunikcrm.com/assets/img/comunik-voip.png",
          body: "Vous avez un appel manqué de la part de    " + num + "",
        });

        notification.onclick = function () {
          window.parent.focus();
          setTimeout(() => {
            history.push("/journal");
          }, 100);
          // console.log(lien);
        };
      } catch (e) {
        if (e.name == "TypeError") return false;
      }
    }
  }
  const isSupported = () =>
    "Notification" in window &&
    "serviceWorker" in navigator &&
    "PushManager" in window;

  useEffect(() => {
    fetchData1();
    fetchDataexterne();
    fetchDatainterne();
    fetchmsgvocal();

    if (isSupported()) {
      document.addEventListener("DOMContentLoaded", function () {
        if (!Notification) {
          alert(
            "Desktop notifications not available in your browser. Try Chromium."
          );
          return;
        }

        if (Notification.permission !== "granted")
          Notification.requestPermission();
      });
    } else {
      console.log("not supported");
    }

    //console.log(poste);
    const fetchData = async () => {
      var lien = window.location.href;
      // console.log(lien);
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      //
      const result = axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/InfosColleguesIPBXV3API?compte=${compte}&poste=${poste}`,
          config
        )
        .then((res) => {
          dispatch({ type: "SET_USER_INFO", payload: res.data.collegues[0] });

          setProfile(res.data.collegues[0]);
          //console.log(res.data.collegues[0].nom[0])
          setLetter(res.data.collegues[0].nom[0]);
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    };

    fetchData();
  }, []);
  useEffect(() => {
    const onCloseInterface = (payload = {}) => {
      const eventToken = payload?.AccessToken || payload?.accessToken;
      const currentToken = localStorage.getItem("AccessToken");

      if (!eventToken || !currentToken || eventToken !== currentToken) return;
      forceLogout();
    };

    socket?.on("connect", function () {
      dispatch({ type: "SET_SOCKET", payload: socket });
      socket?.on("broadcast", function (data) {
        if (data.compte !== compte) return;
        if (data.Poste == poste) {
          // showModal();
          if (isSupported()) {
            notifyMe(data.appelant);
          }
          // document.getElementById("manq").classList.add("bg-opacity-100");
          //notif(data.appelant);
          document.getElementById("notif").classList.add("bg-opacity-100");
          //showCustom(data.appelant);
        }
      });
    });
    socket?.on("disconnect", function () {});
    socket?.on("closeInterface", onCloseInterface);
    socket?.on("close-interface", onCloseInterface);

    return () => {
      // socket?.on("disconnect", function () {
      //   console.log("disconnected");
      // });
      socket.off("broadcast");
      socket.off("closeInterface", onCloseInterface);
      socket.off("close-interface", onCloseInterface);
    };
  }, []);

  const upper = (nom) => {
    const name = nom.toString().toUpperCase();
    return name;
  };
  const onStatusChange = (status) => {
    //setProfile
    try {
      if (profile.status_utilisateur === String(status)) return;
      const formData = new FormData();
      formData.append("compte", compte);
      formData.append("poste", poste);
      formData.append("status_utilisateur", status);

      var config = {
        method: "POST",
        url: `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/StatusUtilisateurIPBXV3API`,
        headers: {
          Authorization: token,
        },
        data: formData,
      };

      axios(config)
        .then(function (response) {
          if (response.data.etat_ws === "ERREUR_BOITE_VOCAL_NON_CONFIGURER") {
            return;
          }
          setProfile((p) => ({ ...p, status_utilisateur: String(status) }));
        })
        .catch((err) => {
          if (err.response.data.etat_ws === "ERREUR_BOITE_VOCAL_NON_CONFIGURER")
            notification["error"]({
              message: t("toast.config_email_error"),
              btn: (
                <span
                  role="button"
                  onClick={() => {
                    history.push("/parametres");
                    notification.destroy();
                  }}
                  className=" text-blue-500 flex items-center  hover:underline "
                >
                  {t("toast.click_here")}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6  "
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
                    />
                  </svg>
                </span>
              ),
              placement: "bottomRight",
            });
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="h-screen flex overflow-hidden bg-gray-100">
      <div className="absolute">
        {" "}
        {/* <ToastContainer delay={5000000} position={"bottom-right"} /> */}
      </div>
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 flex z-40 lg:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <div className="relative flex-1 flex flex-col max-w-xs  bg-gray-800">
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute top-0 right-0 -mr-12 pt-2">
                  <button
                    type="button"
                    className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                    onClick={() => setSidebarOpen(false)}
                  >
                    <span className="sr-only">Close sidebar</span>
                    <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </Transition.Child>
              <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
                <div className="flex-shrink-0 flex items-center px-4">
                  <div className="flex items-center">
                    <img
                      className="h-10 w-auto"
                      src={
                        window.switchAPI === "govoice"
                          ? imageSrcGO
                          : imageSrcCMK
                      }
                      // src="https://www.comunikcrm.com/assets/img/comunik-voip.png"
                      alt="Workflow"
                    />

                    <span className="text-white text-sm font-medium ml-2">
                      Go Voice
                    </span>
                  </div>
                </div>
                <nav className="mt-5 px-2 space-y-1">
                  {navigation.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      className={classNames(
                        item.current
                          ? "bg-gray-900 text-white"
                          : "text-gray-300 hover:bg-gray-700 hover:text-white",
                        "group flex items-center px-2 py-2 text-base font-medium rounded-md"
                      )}
                    >
                      <item.icon
                        className={classNames(
                          item.current
                            ? "text-gray-300"
                            : "text-gray-400 group-hover:text-gray-300",
                          "mr-4 flex-shrink-0 h-6 w-6"
                        )}
                        aria-hidden="true"
                      />
                      {item.name}
                    </a>
                  ))}
                  <NavLink
                    to={{
                      pathname: "/boitevocale",
                    }}
                    activeClassName="text-gray-400"
                    className="space-y-1 text-gray-200 dark:text-white dark:text-opacity-80 hover:text-primary group flex items-center px-1 py-1 text-sm font-medium rounded-md"
                  >
                    {" "}
                    <Voicemail
                      className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                      aria-hidden="true"
                    />
                    {t("boitevocale")}
                    {state.msgvocaux != 0 ? (
                      <span className="block h-5 w-5 rounded-full  bg-red-600 ml-5">
                        {" "}
                        <h6 className="flex justify-center text-xs  text-white -ml-0.5 ">
                          {" "}
                          {state.msgvocaux}
                        </h6>
                      </span>
                    ) : (
                      <p></p>
                    )}
                  </NavLink>
                  {/* <Link
                    to={{
                      pathname: "/chat",
                      state: {
                        fromDashboard:
                          "https://element.gomybiz.net/#/room/!hvHVipmFQpDaznRrls:gomybiz.net",
                      },
                    }}
                    className="px-2 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary
               flex items-center px-2 py-2 text-sm font-medium rounded-md"
                  >
                    {" "}
                    <MessageSquare
                      className="text-gray-400 -hover:text-gray-500
                  mr-3 h-6 w-6"
                      aria-hidden="true"
                    />
                    Chat
                  </Link> */}
                  <Link
                    onClick={onclicketat}
                    to="/journal"
                    className=" space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary
              group flex items-center px-1 py-1 text-sm font-medium rounded-md"
                  >
                    <span className="flex-shrink-0 inline-block relative">
                      <span>
                        <span
                          id="notif"
                          className="absolute top-0 left-0 block h-2 w-2 rounded-full bg-red-500 bg-opacity-0"
                        ></span>
                      </span>
                      <Clock
                        className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                        aria-hidden="true"
                      />
                    </span>
                    {t("journal.title")}
                  </Link>
                </nav>
              </div>
              <hr
                className="border-t border-gray-400 my-5"
                aria-hidden="true"
              />
              <div className="flex items-center flex-shrink-0 px-4">
                <div className="px-2 space-y-1">
                  <Link
                    key="Profile"
                    to={{
                      pathname: "/profile",
                    }}
                    className="px-2 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary
              group flex items-center  py-2 text-sm font-medium rounded-md"
                  >
                    {" "}
                    <Settings
                      className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                      aria-hidden="true"
                    />
                    {t("profil")}
                  </Link>
                  {/* <Link
                key="Parametre"
                to="/paramtre"
                className="px-2 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary
              group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                {" "}
                <Settings
                  className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                  aria-hidden="true"
                />
                Parametre
              </Link> */}
                  <Toggle />
                  <button
                    type="button"
                    onClick={showModal2}
                    className=" space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary
              group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                  >
                    <LogOut
                      className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-5 w-5"
                      aria-hidden="true"
                    />
                    {t("deconnexion")}{" "}
                  </button>
                </div>
              </div>
              <div className="flex-shrink-0 flex border-t border-gray-400 py-2">
                <div className="flex-shrink-0 w-full group block">
                  <div className="flex items-center">
                    <div></div>
                    <div className="ml-1 flex">
                      <span className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-gray-500">
                        {profile.photo_poste_interne ? (
                          <span className="flex-shrink-0 inline-block relative">
                            <img
                              src={profile.lien_photo_poste_interne}
                              alt={"preview"}
                              className="h-14 w-14 rounded-full"
                            />

                            <span className="absolute top-0 right-0 block h-2.5 w-2.5 rounded-full h-2.5 w-2.5">
                              <svg
                                className="h-6 w-6"
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fas"
                                data-icon="random"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                data-fa-i2svg=""
                              >
                                <path
                                  fill="currentColor"
                                  d="M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
                                ></path>
                              </svg>
                            </span>
                          </span>
                        ) : (
                          <span className="font-medium leading-none text-white text-base">
                            {upper(letter)}
                          </span>
                        )}
                      </span>
                      <p className="runcate ml-2">
                        <span className="block font-semibold text-base truncate mb-0.5 text-white">
                          {profile.nom}
                        </span>

                        <span className="block font-semibold text-base  mb-0.5 text-white">
                          {profile.poste}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
          <div className="flex-shrink-0 w-14">
            {/* Force sidebar to shrink to fit close icon */}
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop /////////////////////////////////////////////*/}
      <div className="hidden lg:flex lg:flex-shrink-0">
        <div className="flex flex-col w-56">
          <div
            className={
              window.switchAPI === "govoice"
                ? "flex-1 flex flex-col min-h-0  dark:bg-gray-900 dark:text-white transition-al  border-r border-gray-200 bg-gray-800 "
                : "flex-1 flex flex-col min-h-0  dark:bg-gray-900 dark:text-white transition-al  border-r border-gray-200 bg-green-800 "
            }
          >
            <div className="ml-8 mt-4 flex items-center px-2 lg:px-0 xl:w-72">
              <div className="flex-shrink-0">
                <div className="flex items-center">
                  <img
                    className="h-10 w-auto"
                    src={
                      window.switchAPI === "govoice" ? imageSrcGO : imageSrcCMK
                    }
                    alt="Workflow"
                  />

                  <span className="text-white text-sm font-medium ml-2">
                    {window.switchAPI === "govoice"
                      ? "GO Voice"
                      : "Comunik voip"}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex-1 flex flex-col pt-5 pb-2 overflow-y-auto">
              <div
                className="flex items-center flex-shrink-0 px-2"
                style={{ height: "30%" }}
              >
                <div className="px-1 space-y-1">
                  <NavLink
                    exact
                    to={{
                      pathname: "/",
                    }}
                    className="px-1 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary group flex items-center px-1 py-1 text-sm font-medium rounded-md"
                    activeClassName="px-1 space-y-1 text-gray-500 dark:text-gray-400 dark:text-opacity-80 hover:text-primary group flex items-center px-1 py-1 text-sm font-medium rounded-md"
                  >
                    {" "}
                    <Users
                      className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                      aria-hidden="true"
                    />
                    {t("colleguetitle")}
                  </NavLink>
                  <NavLink
                    to={{
                      pathname: "/contact",
                    }}
                    className="px-1 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary group flex items-center px-1 py-1 text-sm font-medium rounded-md"
                    activeClassName="px-1 space-y-1 text-gray-500 dark:text-gray-400 dark:text-opacity-80 hover:text-primary group flex items-center px-1 py-1 text-sm font-medium rounded-md"
                  >
                    {" "}
                    <BookOpen
                      className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                      aria-hidden="true"
                    />
                    Contacts
                  </NavLink>

                  <NavLink
                    to={{
                      pathname: "/boitevocale",
                    }}
                    className="px-1 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary group flex items-center px-1 py-1 text-sm font-medium rounded-md"
                    activeClassName="px-1 space-y-1 text-gray-500 dark:text-gray-400 dark:text-opacity-80 hover:text-primary group flex items-center px-1 py-1 text-sm font-medium rounded-md"
                  >
                    {" "}
                    <Voicemail
                      className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                      aria-hidden="true"
                    />
                    {t("boitevocale")}
                    {state.msgvocaux != 0 ? (
                      <span className="block h-5 w-5 rounded-full  bg-red-600 ml-5">
                        {" "}
                        <h6 className="flex justify-center text-xs  text-white -ml-0.5 ">
                          {" "}
                          {state.msgvocaux}
                        </h6>
                      </span>
                    ) : (
                      <p></p>
                    )}
                  </NavLink>

                  <NavLink
                    onClick={onclicketat}
                    to="/journal"
                    className="px-1 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary group flex items-center px-1 py-1 text-sm font-medium rounded-md"
                    activeClassName="px-1 space-y-1 text-gray-500 dark:text-gray-400 dark:text-opacity-80 hover:text-primary group flex items-center px-1 py-1 text-sm font-medium rounded-md"
                  >
                    <span className="flex-shrink-0 inline-block relative">
                      <span>
                        <span
                          id="notif"
                          className="absolute top-0 left-0 block h-2 w-2 rounded-full bg-red-500 bg-opacity-0"
                        ></span>
                      </span>
                      <Clock
                        className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                        aria-hidden="true"
                      />
                    </span>
                    {t("journal.title")}{" "}
                  </NavLink>
                  {access_rmc === "true" && url_rmc && token_rmc && (
                    <NavLink
                      to="/SupportBoard"
                      className=" space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary group flex items-center px-1 py-1 text-sm font-medium rounded-md"
                      activeClassName="px-1 space-y-1 text-gray-500 dark:text-gray-400 dark:text-opacity-80 hover:text-primary group flex items-center px-1 py-1 text-sm font-medium rounded-md"
                    >
                      <span className="flex-shrink-0 inline-block relative">
                        <span>
                          <span
                            id="notif"
                            className="absolute top-0 left-0 block h-2 w-2 rounded-full bg-red-500 bg-opacity-0"
                          ></span>
                        </span>
                        <Share2
                          className="text-gray-400 group-hover:text-gray-500
                      mr-3 h-6 w-6"
                          aria-hidden="true"
                        />
                      </span>
                      RMC
                    </NavLink>
                  )}
                </div>
              </div>

              {/* <hr className="border-t border-gray-400" aria-hidden="true" /> */}
              <div className="" style={{ height: "64%" }}>
                {isWEB === "WEBRTC" ? <Webphone /> : null}
                {/* <QRCode value="hey" /> */}
              </div>
            </div>

            <div className="flex-shrink-0 flex border-t border-gray-400 p-1">
              <div className="flex-shrink-0 w-full  block">
                <div className="flex items-center">
                  <div></div>

                  <span className="ml-4 inline-flex sm:ml-0 pt-1">
                    <Menu as="div" className="relative inline-block text-left ">
                      {({ open, close }) => (
                        <>
                          <Menu.Button
                            className="items-center justify-center"
                            //className="inline-flex items-center p-2 shadow-sm text-sm font-medium text-gray-400 bg-white hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-gray-300">
                          >
                            <div className=" flex">
                              <span className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-gray-500 relative">
                                {profile.photo_poste_interne ? (
                                  <span className="flex-shrink-0 inline-block relative">
                                    <img
                                      src={profile.lien_photo_poste_interne}
                                      alt={"preview"}
                                      className="h-14 w-14 rounded-full"
                                    />
                                    {/* {etattransfert ? ( */}
                                    {state.renvoidirect ||
                                    state.renvoiinterne ||
                                    state.renvoiexterne ? (
                                      <span className="absolute top-0 right-0 block rounded-full h-4 w-4 bg-yellow-600">
                                        <svg
                                          className="flex-1 flex  justify-center  ml-0.5 mt-0.5 h-3 w-3 text-green-800 dark:text-gray-900"
                                          aria-hidden="true"
                                          focusable="false"
                                          data-prefix="fas"
                                          data-icon="random"
                                          role="img"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 512 512"
                                          data-fa-i2svg=""
                                        >
                                          <path
                                            fill="currentColor"
                                            d="M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
                                          ></path>
                                        </svg>
                                      </span>
                                    ) : (
                                      <div></div>
                                    )}
                                  </span>
                                ) : (
                                  <span className="font-medium leading-none text-white text-base ">
                                    {upper(letter)}
                                    {/* {etattransfert ? ( */}

                                    {state.renvoidirect ? (
                                      <span className="absolute top-0 right-0 block rounded-full h-4 w-4 bg-yellow-600">
                                        <svg
                                          className="flex-1 flex  justify-center  ml-0.5 mt-0.5 h-3 w-3 text-green-800 dark:text-gray-900"
                                          aria-hidden="true"
                                          focusable="false"
                                          data-prefix="fas"
                                          data-icon="random"
                                          role="img"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 512 512"
                                          data-fa-i2svg=""
                                        >
                                          <path
                                            fill="currentColor"
                                            d="M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
                                          ></path>
                                        </svg>
                                      </span>
                                    ) : (
                                      <div></div>
                                    )}
                                  </span>
                                )}
                                <div className=" absolute bottom-0 -right-1">
                                  {renderStatus(profile?.status_utilisateur, t)}
                                </div>
                              </span>
                              <div className=" flex justify-between items-center">
                                <p className="truncate ml-4">
                                  <span className="block font-semibold text-base  mb-0.5 text-white">
                                    {profile.nom}
                                  </span>
                                  <span className="flex  font-semibold text-base  mb-0.5 text-white">
                                    {profile.poste}
                                    <ChevronDownIcon
                                      className="h-5 w-5 ml-1  text-white"
                                      aria-hidden="true"
                                    />
                                  </span>
                                </p>
                              </div>
                            </div>
                          </Menu.Button>
                          <Transition
                            show={open}
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items
                              static
                              className="border border-white dark:bg-gray-700 bg-white origin-top-left absolute left-0  ml-8 -mt-44 w-44 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                              style={{
                                zIndex: "9999",
                                //backgroundColor: "#3d6d60",
                              }}
                            >
                              <div className="py-1 px-3 w-full">
                                <Menu>
                                  <Menu.Button className="w-full">
                                    <button
                                      className=" group relative space-y-1 w-full justify-between  text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary dark:group-hover:text-white
                    flex items-center px-1 py-1 text-sm font-medium rounded-md"
                                    >
                                      <div className="flex items-center">
                                        <CheckCircle
                                          className="text-gray-400 group-hover:text-primary dark:group-hover:text-white
                  mr-3 h-6 w-6"
                                          aria-hidden="true"
                                        />
                                        <span>{t("status.avaibality")}</span>
                                      </div>
                                      <ChevronRightIcon className="text-gray-400 h-4 w-4   group-hover:text-primary dark:group-hover:text-white" />
                                    </button>
                                  </Menu.Button>
                                  <Transition
                                    style={{
                                      zIndex: "99",
                                    }}
                                  >
                                    <Menu.Items
                                      static
                                      className="border dark:border-white border-green-700 dark:bg-gray-700 bg-white origin-top-left fixed
                                        bottom-10 left-52 ml-2 w-40 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                    >
                                      <div className="py-1 px-3">
                                        <Menu.Item
                                          disabled={
                                            profile.status_utilisateur === "0"
                                          }
                                        >
                                          <button
                                            onClick={() => {
                                              onStatusChange(0);
                                            }}
                                            className={`
                                                w-full ${
                                                  profile.status_utilisateur ===
                                                  "0"
                                                    ? "text-primary  dark:text-primary  "
                                                    : "text-gray-400 hover:text-primary  dark:hover:text-gray-100 dark:text-white dark:text-opacity-60 "
                                                } 
                   flex items-center p-1 font-medium 
                                              
                                              `}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              className="h-6 w-6"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              stroke="currentColor"
                                              strokeWidth={2}
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                              />
                                            </svg>
                                            <span className="ml-0.5">
                                              {t("status.available")}
                                            </span>
                                          </button>
                                        </Menu.Item>
                                        <Menu.Item
                                          disabled={
                                            profile.status_utilisateur === "3"
                                          }
                                        >
                                          <button
                                            onClick={() => onStatusChange(3)}
                                            className={` w-full
                                            
                                            ${
                                              profile.status_utilisateur === "3"
                                                ? "text-yellow-400 dark:text-yellow-300"
                                                : "text-gray-400 hover:text-yellow-400  dark:hover:text-gray-100 dark:text-white dark:text-opacity-60 "
                                            }
                                               
                                           flex items-center p-1 font-medium`}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              className="h-11 w-11 "
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              stroke="currentColor"
                                              strokeWidth={2}
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                              />
                                            </svg>
                                            <span
                                              style={{
                                                fontSize: "11px",
                                                lineHeight: "1.4",
                                                marginLeft: "3px",
                                              }}
                                              className=" text-left  "
                                            >
                                              {" "}
                                              {t("status.backInFewMin")}
                                            </span>
                                          </button>
                                        </Menu.Item>

                                        <Menu.Item
                                          disabled={
                                            profile.status_utilisateur === "1"
                                          }
                                        >
                                          <button
                                            onClick={() => onStatusChange(1)}
                                            className={`
                                            
                                            w-full ${
                                              profile?.status_utilisateur ===
                                              "1"
                                                ? "text-red-400"
                                                : "text-gray-400  hover:text-red-400 dark:text-white dark:hover:text-gray-100 dark:text-opacity-60"
                                            }    
                                            flex items-center  font-medium p-1`}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              className="h-6 w-6"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              stroke="currentColor"
                                              strokeWidth={2}
                                            >
                                              <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                                              />
                                            </svg>

                                            <span className="ml-0.5">
                                              {t("status.busy")}
                                            </span>
                                          </button>
                                        </Menu.Item>
                                        <Menu.Item
                                          disabled={
                                            profile.status_utilisateur === "4"
                                          }
                                        >
                                          <button
                                            onClick={() => onStatusChange(4)}
                                            className={`
                                            ${
                                              profile.status_utilisateur === "4"
                                                ? "text-yellow-400 dark:text-yellow-300"
                                                : "text-gray-400 hover:text-yellow-400 dark:text-white dark:hover:text-gray-100 dark:text-opacity-60  "
                                            }
                                            w-full  
                                            flex items-centerfont-medium  p-1
                                            `}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              className="h-6 w-6"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              stroke="currentColor"
                                              strokeWidth={2}
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                                              />
                                            </svg>
                                            <span className="ml-0.5">
                                              {" "}
                                              {t("status.away")}
                                            </span>
                                          </button>
                                        </Menu.Item>
                                        <Menu.Item
                                          disabled={
                                            profile.status_utilisateur === "2"
                                          }
                                        >
                                          <button
                                            onClick={() => onStatusChange(2)}
                                            className={`
                                              w-full ${
                                                profile?.status_utilisateur ===
                                                "2"
                                                  ? "text-gray-600 dark:text-gray-500"
                                                  : "text-gray-400 hover:text-gray-600 dark:hover:text-gray-100"
                                              }   
                                              flex items-center p-1  font-medium
                                              `}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              strokeWidth={2}
                                              stroke="currentColor"
                                              style={{
                                                height: "22px",
                                                width: "22px",
                                              }}
                                              className="ml-0.5"
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                                              />
                                            </svg>

                                            <span
                                              style={{
                                                fontSize: "11px",
                                              }}
                                              className="ml-1 text-left "
                                            >
                                              {t("status.donotdisturb")}
                                            </span>
                                          </button>
                                        </Menu.Item>
                                      </div>
                                    </Menu.Items>
                                  </Transition>
                                </Menu>

                                <Menu.Item>
                                  <Link
                                    key="parametres"
                                    to={{
                                      pathname: "/parametres",
                                    }}
                                    className="px-1 group space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary dark:hover:text-white
                                    flex items-center py-1 text-sm font-medium rounded-md"
                                  >
                                    {" "}
                                    <Settings
                                      className="text-gray-400 group-hover:text-primary dark:group-hover:text-white
                  mr-3 h-6 w-6"
                                      aria-hidden="true"
                                    />
                                    <span>{t("profil")}</span>
                                  </Link>
                                </Menu.Item>
                                <Menu.Item>
                                  <Toggle />
                                </Menu.Item>
                                <Divider
                                  className="my-0"
                                  style={{
                                    margin: "5px 0",
                                  }}
                                />
                                <Menu.Item>
                                  <button
                                    type="button"
                                    onClick={showModal2}
                                    className="px-1 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 group hover:text-primary dark:hover:text-white
                  flex items-center py-1 text-sm font-medium rounded-md"
                                  >
                                    <LogOut
                                      className="text-gray-400 group-hover:text-primary dark:group-hover:text-white
                  mr-3 h-5 w-5"
                                      aria-hidden="true"
                                    />
                                    {t("deconnexion")}
                                  </button>
                                </Menu.Item>
                              </div>
                            </Menu.Items>
                          </Transition>
                        </>
                      )}
                    </Menu>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Static sidebar for desktop /////////////////////////////////////////////*/}

      <div className="flex flex-col  flex-1 overflow-hidden dark:bg-gray-900">
        <div className="lg:hidden pl-1 pt-1 sm:pl-3 sm:pt-3">
          <button
            type="button"
            className="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <MenuIcon className="h-6 w-6" aria-hidden="true" />
          </button>
          <div className="flex items-center flex-shrink-0">
            <div className="px-1 space-y-1">
              {navigation.map((sidenav) => (
                <Link
                  key={sidenav.name}
                  to={sidenav.href}
                  className={classNames(
                    sidenav.current
                      ? "dark:text-opacity-90 dark:text-white"
                      : "text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary",
                    "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                  )}
                >
                  <sidenav.icon
                    className={classNames(
                      sidenav.current
                        ? "text-gray-400"
                        : "text-gray-400 group-hover:text-gray-500",
                      "mr-3 h-6 w-6"
                    )}
                    aria-hidden="true"
                  />
                </Link>
              ))}
              <Link
                to={{
                  pathname: "/boitevocale",
                }}
                className="px-1 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary
              group flex items-center px-1 py-1 text-sm font-medium rounded-md"
              >
                {" "}
                <Voicemail
                  className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                  aria-hidden="true"
                />
                {state.msgvocaux != 0 ? (
                  <span className="block h-5 w-5 rounded-full  bg-red-600 ml-5">
                    {" "}
                    <h6 className="flex justify-center text-xs  text-white -ml-0.5 ">
                      {" "}
                      {state.msgvocaux}
                    </h6>
                  </span>
                ) : (
                  <p></p>
                )}
              </Link>
              {/* <Link
                to={{
                  pathname: "/chat",
                  state: {
                    fromDashboard:
                      "https://element.gomybiz.net/#/room/!hvHVipmFQpDaznRrls:gomybiz.net",
                  },
                }}
                className="px-2 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary
              group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                {" "}
                <MessageSquare
                  className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                  aria-hidden="true"
                />
              </Link> */}
              <Link
                onClick={onclicketat}
                to="/journal"
                className="px-2 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary
              group flex items-center  py-1 text-sm font-medium rounded-md"
              >
                <span className="flex-shrink-0 inline-block relative">
                  <span>
                    <span
                      id="notif"
                      className="absolute top-0 left-0 block h-2 w-2 rounded-full bg-red-500 bg-opacity-0"
                    ></span>
                  </span>
                  <Clock
                    className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                    aria-hidden="true"
                  />
                </span>
              </Link>
              <Link
                key="parametres"
                to="/parametres"
                className="px-2 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary
              group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                {" "}
                <User
                  className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                  aria-hidden="true"
                />
              </Link>
              {/* <Link
                key="Parametre"
                to="/paramtre"
                className="px-2 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary
              group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                {" "}
                <Settings
                  className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-6 w-6"
                  aria-hidden="true"
                />
                Parametre
              </Link> */}
              <button
                type="button"
                onClick={showModal2}
                className="px-2 space-y-1 text-gray-400 dark:text-white dark:text-opacity-80 hover:text-primary
              group flex items-center px-2 py-2 text-sm font-medium rounded-md"
              >
                <LogOut
                  className="text-gray-400 group-hover:text-gray-500
                  mr-3 h-5 w-5"
                  aria-hidden="true"
                />
              </button>
              {/* <Toggle /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default withTranslation("common")(Sidebar);
